// src/components/Illinois.js
import React, { useState } from 'react';
import './Illinois.css';

const Illinois = () => {
  const [activeFaq, setActiveFaq] = useState(null);
  const [formData, setFormData] = useState({
    fullName: '',
    practiceName: '',
    email: '',
    phone: '',
    specialty: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const response = await fetch('https://formspree.io/f/xrejwqgl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ ...formData, state: 'Illinois' })
      });

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Thank you! We will contact you shortly about our services in Illinois.' });
        setFormData({ fullName: '', practiceName: '', email: '', phone: '', specialty: '', message: '' });
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Something went wrong. Please try again or call us directly.' });
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus({ type: '', message: '' }), 5000);
    }
  };

  const servicesList = [
    'MEDICAL CODING SERVICES IN ILLINOIS!',
    'CREDENTIALING SERVICES IN ILLINOIS!',
    'ACCOUNT RECEIVABLE SERVICES IN ILLINOIS!',
    'ELIGIBILITY VERIFICATION SERVICES IN ILLINOIS!',
    'PATIENT BILLING SERVICES IN ILLINOIS!',
    'OUT OF NETWORK NEGOTIATION SERVICES IN ILLINOIS!',
    'CLEAN-UP MEDICAL BILLING AUDIT SERVICES',
    'PRIOR AND RETRO AUTHORIZATION SERVICES'
  ];

  const serviceDetails = {
    'MEDICAL CODING SERVICES IN ILLINOIS!': {
      description: 'Associate medical coding is a critical part of managing reimbursement and maintaining a healthy revenue cycle. From initial patient encounters to final claim submission, our coding services ensure that all claims are accurately coded and submitted on time. Our team of certified medical coders is available 24/7 to assist with any coding questions or concerns.'
    },
    'CREDENTIALING SERVICES IN ILLINOIS!': {
      description: 'Providers Care Billing LLC is an expert provider of medical credentialing services. We offer a wide range of services including:',
      subItems: ['CREDIT REPORTS: Generate detailed reports for physicians and other healthcare providers.', 'DENIAL REVIEW: Identify and resolve denied claims promptly.', 'INPATIENT RECONCILIATION: Assist in resolving discrepancies between hospital and physician records.', 'MEDICATION REIMBURSEMENT: Process and submit claims for reimbursement of medications prescribed by physicians.']
    },
    'ACCOUNT RECEIVABLE SERVICES IN ILLINOIS!': {
      description: 'The Accounts Receivable department plays a crucial role in managing accounts receivable. Our team of experienced professionals ensures timely payments, reducing the risk of bad debt and improving cash flow. We offer a variety of services, including:',
      subItems: ['ACH PAYMENTS: Process ACH payments directly into bank accounts.', 'AR COLLECTION: Collect accounts receivable from patients and insurance payors.', 'BANK TRANSFERS: Transfer funds between banks as needed.']
    },
    'ELIGIBILITY VERIFICATION SERVICES IN ILLINOIS!': {
      description: 'Our primary focus is on verifying eligibility for coverage in Illinois. This includes reviewing medical necessity documentation, verifying insurance coverage, and ensuring compliance with state and federal regulations. We also assist with appeals and denials.'
    },
    'PATIENT BILLING SERVICES IN ILLINOIS!': {
      description: 'To expedite the billing process, we use automated systems to generate bills, send invoices, and process payments. We also offer a variety of billing options, including:',
      subItems: ['Billing Statements: Generate statements for patients and insurance payors.', 'Billing Invoices: Send invoices electronically to patients and insurance payors.', 'Billing Reminders: Send reminders to patients and insurance payors about upcoming due dates.']
    },
    'OUT OF NETWORK NEGOTIATION SERVICES IN ILLINOIS!': {
      description: 'Negotiating the best network terms and conditions is essential to maximize savings. Our team of experts can help you navigate the complex world of healthcare reimbursement and negotiate favorable rates with various insurers.'
    },
    'CLEAN-UP MEDICAL BILLING AUDIT SERVICES': {
      description: 'Providers Care Billing LLC is dedicated to ensuring that claims are processed accurately and efficiently. Our audit services include:',
      subItems: ['QUALITY CONTROL: Ensure claims are processed correctly and in accordance with industry standards.', 'DATA ANALYSIS: Analyze data to identify areas for improvement and cost savings.', 'DOCUMENTATION: Maintain thorough documentation of all claims and payments.']
    },
    'PRIOR AND RETRO AUTHORIZATION SERVICES': {
      description: "Don't let authorization headaches hold you back. With Providers Care Billing LLC, you can streamline your authorization process and reduce administrative burden. Our team of experts can help you navigate the complexities of authorizations and ensure compliance with regulatory requirements."
    }
  };

  const faqs = [
    { q: 'What are the top medical billing services in Illinois?', a: 'Providers Care Billing LLC offers comprehensive medical billing services including coding, credentialing, AR recovery, eligibility verification, patient billing, out of network negotiation, billing audits, and authorization services.' },
    { q: 'Do you offer physician credentialing services in Illinois?', a: 'Yes, we offer complete physician credentialing services in Illinois including CAQH credentialing, payer enrollment services, and provider enrollment services.' },
    { q: 'Can you provide a list of medical billing services in Illinois?', a: 'Our services include Medical Coding, Credentialing, Account Receivable Management, Eligibility Verification, Patient Billing, Out of Network Negotiation, Billing Audits, and Authorization Services.' },
    { q: 'What is the Role of Medical Billing Companies in Illinois?', a: 'Medical billing companies help healthcare providers manage claims, reduce denials, improve cash flow, ensure compliance, and handle credentialing with insurance companies.' },
    { q: 'Who offers the best medical billing services in Illinois?', a: 'Providers Care Billing LLC is recognized as one of the top medical billing companies in Illinois with 99% claim acceptance rate and 98.71% clean claims submission.' },
    { q: 'How much does it cost to outsource medical billing and coding in Illinois?', a: 'Our services start at just 2.49% of collections with no hidden fees. We get paid when you get paid.' },
    { q: 'Where can I find medical billing services in Illinois with positive reviews?', a: 'With hundreds of positive reviews from satisfied healthcare providers across Illinois.' },
    { q: 'Can your company handle complex medical billing and coding procedures?', a: 'Yes, our certified coders and billers are experienced in handling complex billing procedures across all medical specialties.' }
  ];

  return (
    <main className="illinois-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="container">
          <span className="breadcrumb-item">Home</span>
          <span className="breadcrumb-separator">→</span>
          <span className="breadcrumb-item">States We Serve</span>
          <span className="breadcrumb-separator">→</span>
          <span className="breadcrumb-item active">Illinois</span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="illinois-hero">
        <div className="container">
          <div className="illinois-hero-content">
            <h1 className="illinois-hero-title">
              Medical Billing Services <span className="highlight">in Illinois!</span>
            </h1>
            <p className="illinois-hero-description">
              At Providers Care Billing LLC, we deliver comprehensive medical billing services in Illinois, including Chicago, 
              Aurora, Naperville, Joliet, Rockford, Springfield, Peoria, Elgin, Waukegan, Cicero, and nearby areas. Our services 
              cover billing, coding, AR recovery, and medical credentialing services for physicians, therapists, mental health 
              providers, and group practices.
            </p>
            <p className="illinois-hero-description">
              Many Illinois providers struggle with insurance credentialing, payer enrollment, and CAQH updates and we handle 
              that entire process for you so your practice stays compliant and gets paid faster.
            </p>
            <button className="hero-talk-btn">TALK TO OUR BILLING EXPERT →</button>
          </div>
        </div>
      </section>

      {/* Struggling Section */}
      <section className="illinois-struggling">
        <div className="container">
          <div className="struggling-content">
            <h2 className="struggling-title">Struggling With Medical Billing Services in Illinois?</h2>
            <p className="struggling-text">
              Managing a fully efficient medical practice in Illinois while keeping your medical billing department running 
              smoothly can be overwhelming. That's why choosing a reliable and professional medical billing company in Illinois 
              is essential for your practice's success.
            </p>
            <p className="struggling-text">
              At Providers Care Billing LLC, we simplify the complexities of medical billing and coding. Our expert medical 
              billing services in Illinois deliver seamless revenue cycle management, improved cash flow, and reduced 
              administrative workload—allowing you to concentrate on providing outstanding patient care.
            </p>
            <p className="struggling-text">
              As one of the top credentialing companies in Illinois, we offer specialized medical credentialing services and 
              insurance credentialing services designed to meet the unique needs of primary care providers, hospitals, emergency 
              departments, and specialty practices. Our expertise includes CAQH credentialing, comprehensive payer enrollment 
              services, and provider enrollment services that help you stay compliant and get paid faster.
            </p>
          </div>
        </div>
      </section>

      {/* Partner Section */}
      <section className="illinois-partner">
        <div className="container">
          <div className="partner-content">
            <h2 className="partner-title">
              Partner with Providers Care Billing LLC, Your Trusted Medical Billing Company in Illinois
            </h2>
            <p className="partner-text">
              Start your journey to stress-free billing and credentialing today with Providers Care Billing LLC—your go-to for 
              expert medical billing services in Illinois and comprehensive credentialing services support.
            </p>
            <button className="partner-consult-btn">REQUEST A FREE CONSULTATION →</button>
          </div>
        </div>
      </section>

      {/* Outsourcing Benefits Section */}
      <section className="illinois-benefits">
        <div className="container">
          <h2 className="benefits-main-title">
            How Outsourcing to Providers Care Billing LLC Boosts Medical Billing Services in Illinois?
          </h2>
          <p className="benefits-subtitle">
            Our team helps physicians and mental health providers across Illinois streamline their RCM with accurate coding, 
            compliance support, and clean claims. Whether you need an experienced medical billing agency or complete healthcare 
            billing solutions, we deliver transparent reporting, daily claim submission, and 96% clean claim rates.
          </p>
          <div className="benefits-cards">
            <div className="benefit-card-illinois">
              <div className="benefit-icon">💰</div>
              <h3>Enhanced Revenue</h3>
              <p>Our team of skilled medical billing specialists excels in medical billing and coding audits, claim processing, and denial management. By capitalizing on our industry proficiency, we can help you optimize your revenue while minimizing the risks associated with denied or lost claims.</p>
            </div>
            <div className="benefit-card-illinois">
              <div className="benefit-icon">📊</div>
              <h3>Improved Financial Stability</h3>
              <p>Our expert team provides full-time accounting support, ensuring your financial stability. We assist with tax preparation, payroll, and other critical financial tasks.</p>
            </div>
            <div className="benefit-card-illinois">
              <div className="benefit-icon">⏰</div>
              <h3>Minimized Administrative Tasks</h3>
              <p>By outsourcing your medical billing and coding processes, you can liberate your staff from administrative tasks, allowing them to dedicate their time and resources exclusively to enhancing patient care.</p>
            </div>
          </div>
          <div className="book-appointment-center">
            <button className="book-appoint-btn">BOOK YOUR APPOINTMENT NOW! →</button>
          </div>
        </div>
      </section>

      {/* Services We Offer Section */}
      <section className="illinois-services">
        <div className="container">
          <h2 className="services-main-title">Medical Billing Services We Offer in Illinois!</h2>
          <p className="services-subtitle">
            As Providers Care Billing LLC—one of the top medical billing companies in Illinois—we provide comprehensive revenue 
            cycle management services. Covering every step from patient arrival to the receipt of payment.
          </p>
          <p className="services-text">
            Our team of skilled medical billing specialists is committed to providing fast and accurate claims processing, 
            ensuring peace of mind and reliable results. By minimizing revenue losses and maximizing reimbursement, we help 
            healthcare providers overcome the common challenges of financial management.
          </p>
          <p className="services-text">
            At Providers Care Billing LLC, our expert billers and coders are strategically located across Illinois, serving 
            major cities like Chicago, Springfield, Peoria, and Rockford. Whether you need efficient revenue cycle management 
            or comprehensive medical billing services in Illinois, we're here to support your practice and boost your financial outcome.
          </p>

          {/* Service Details */}
          {servicesList.map((service, index) => {
            const details = serviceDetails[service];
            return (
              <div className="service-detail-block" key={index}>
                <h3 className="service-detail-title">{service}</h3>
                <p className="service-detail-text">{details.description}</p>
                {details.subItems && (
                  <ul className="service-detail-list">
                    {details.subItems.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* Staff Training Section */}
      <section className="illinois-training">
        <div className="container">
          <div className="training-content">
            <h2 className="training-title">Extensive Front Desk Staff Training!</h2>
            <p className="training-text">
              At Providers Care Billing LLC, we go above and beyond to ensure your practice runs smoothly. Our dedicated team 
              handles every aspect of medical billing and coding, patient scheduling, and registration while also providing 
              extensive staff training. From verifying insurance eligibility to managing copayments and deductibles, we equip 
              your team with the tools and knowledge needed to deliver exceptional patient care.
            </p>
            <p className="training-text">
              After you deliver exceptional patient care, we ensure your claims are meticulously prepared, achieving an 
              outstanding <strong>99.9% acceptance rate</strong>. Our experts manage the entire claim process, from error-free 
              submissions to thorough follow-ups on patient statements. We also provide comprehensive, professional assistance 
              to patients, addressing their inquiries with care and efficiency.
            </p>
            <p className="training-text">
              Partner with us for reliable and seamless medical billing services in Illinois, and let us help you optimize your 
              practice's revenue cycle management.
            </p>
            <button className="training-book-btn">BOOK YOUR APPOINTMENT NOW! →</button>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="illinois-faq">
        <div className="container">
          <h2 className="faq-main-title">Frequently Asked Questions</h2>
          <div className="faq-grid-illinois">
            {faqs.map((faq, index) => (
              <div className={`faq-item-illinois ${activeFaq === index ? 'active' : ''}`} key={index}>
                <div className="faq-question-illinois" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <button className="faq-toggle-illinois">{activeFaq === index ? '−' : '+'}</button>
                </div>
                <div className="faq-answer-illinois">
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="illinois-cta">
        <div className="container">
          <div className="cta-illinois-content">
            <h2>Looking For The Best Medical Billing And Credentialing Services In Illinois?</h2>
            <p>Schedule a free consultation today and let our team handle your billing, coding, and payer enrollment needs.</p>
            <button className="cta-illinois-btn" onClick={() => document.getElementById('consultation-form').scrollIntoView({ behavior: 'smooth' })}>
              Book Your Free Consultation →
            </button>
          </div>
        </div>
      </section>

      {/* Consultation Form Section */}
      <section className="illinois-consultation" id="consultation-form">
        <div className="container">
          <div className="consultation-wrapper">
            <h2 className="consultation-title">Request a Free Consultation</h2>
            {submitStatus.message && (
              <div className={`form-status ${submitStatus.type}`}>
                {submitStatus.message}
              </div>
            )}
            <form onSubmit={handleSubmit} className="consultation-form-illinois">
              <div className="form-row">
                <div className="form-group">
                  <input type="text" name="fullName" placeholder="Full Name" value={formData.fullName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="text" name="practiceName" placeholder="Practice Name" value={formData.practiceName} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <input type="text" name="specialty" placeholder="Medical Specialty" value={formData.specialty} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <textarea name="message" rows="3" placeholder="Tell us about your practice..." value={formData.message} onChange={handleChange}></textarea>
                </div>
              </div>
              <button type="submit" className="submit-illinois-btn" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit Request →'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Illinois;